/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RefundOwnerType {
  ORDER = 'order',
  VOUCHER = 'voucher',
  PASS = 'pass',
}
